import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import { putRequest } from '../../../../services/base'
import { NavContext } from '../../../../context/global_context'
import {
  SalesCodesContext,
  UPDATE_CHANGE_SALES_CODE_DATA,
} from '../context/context'
import InlineCheckbox from '../../../common/InlineCheckbox'

const SalesCodeForm = (props) => {
  const [salesCodeDetails, setSalesCodeDetails] = useState({})
  const [value, dispatch] = useContext(NavContext)
  const [salesCodeState, salesCodeDispatch] = useContext(SalesCodesContext)

  useEffect(() => {
    if (salesCodeState?.selectedObject?.id) {
      setSalesCodeDetails(salesCodeState.selectedObject)
    }
  }, [salesCodeState?.selectedObject])

  const saveSalesCodeDetails = async () => {
    let res = await putRequest(
      `/api/sales_codes/save_sales_codes/${salesCodeDetails.id}/`,
      salesCodeDetails
    )
    dispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: `Data saved successfully`,
      },
    })

    salesCodeDispatch({
      type: UPDATE_CHANGE_SALES_CODE_DATA,
      data: salesCodeDetails,
    })
    props.onSave()
  }

  return (
    <div className="">
      <form
        onSubmit={(e) => {
          e.preventDefault()
          saveSalesCodeDetails(e)
        }}
      >
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="name"
              type="text"
              label="Name"
              value={salesCodeDetails?.name}
              onChange={(value) => {
                setSalesCodeDetails({ ...salesCodeDetails, name: value })
              }}
              readOnly={true}
            />
          </div>
          <div className="w-1/2">
            <InputText
              name="description"
              type="text"
              label="Description"
              value={salesCodeDetails?.description}
              onChange={(value) => {
                setSalesCodeDetails({ ...salesCodeDetails, description: value })
              }}
            />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="group_name"
              type="text"
              label="Group Name"
              value={salesCodeDetails?.group?.name}
              onChange={(value) => {
                setSalesCodeDetails({
                  ...salesCodeDetails,
                  group: { ...salesCodeDetails.group, name: value },
                })
              }}
              readOnly={true}
            />
          </div>
          <div className="w-1/2">
            <InputText
              name="group_description"
              type="text"
              label="Group Description"
              value={salesCodeDetails?.group?.description}
              onChange={(value) => {
                setSalesCodeDetails({
                  ...salesCodeDetails,
                  group: { ...salesCodeDetails.group, description: value },
                })
              }}
            />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InlineCheckbox
              type="checkbox"
              onChange={(value) => {
                setSalesCodeDetails({ ...salesCodeDetails, default: value })
              }}
              label="Default"
              name="default"
              value={salesCodeDetails.default}
              className={'text-white'}
            />
          </div>
        </div>
        <div className="flex justify-end">
          <div className="w-1/4 mr-2">
            <Button
              type="submit"
              className={`cursor-pointer btn my-4 w-full justify-end`}
              onClick={(e) => {}}
              value={'text'}
              text={'Save'}
            />
          </div>
        </div>
      </form>
    </div>
  )
}

SalesCodeForm.propTypes = {
  onSave: PropTypes.func.isRequired,
}

export default SalesCodeForm
